import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "OAtributosChips" }

import { MListaChips } from "@/components/Gerais"
  import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
  import { onMounted, ref } from "vue"

  interface Props {
    idsAtributos: string[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAtributosChips',
  props: {
    idsAtributos: null
  },
  setup(__props: any) {

const props = __props as {
    idsAtributos: string[]
  }

  

  const OPERADOR_IGUAL = "igual."
  const atributos = ref<string[]>()

  const atributosRep = new AtributosRepositorio()

  const requisitarMultiplasAtributos = async () => {
    let nomeAtributos: string[] = []
    await Promise.allSettled(
      props.idsAtributos.map((id) =>
        atributosRep
          .listarAtributos({
            id: OPERADOR_IGUAL + id,
            "ordenar-por": "asc.nome",
          })
          .then((response) => {
            const nome = response.resultados[0].nome || ""
            nomeAtributos.push(nome)
          })
          .catch(Promise.reject)
      )
    )
    return Promise.resolve(nomeAtributos)
  }
  onMounted(async () => {
    try {
      atributos.value = await requisitarMultiplasAtributos()
    } catch (erro) {
      console.error(erro)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!atributos.value)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          width: "100%"
        }))
      : (_openBlock(), _createBlock(_unref(MListaChips), {
          key: 1,
          chips: atributos.value,
          class: "OAtributosChips__Lista",
          "exibir-somente": 3
        }, null, 8, ["chips"]))
  ]))
}
}

})